<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      :fill="props.color"
      d="M12.4688 5.5C13.021 5.5 13.4688 5.05228 13.4688 4.5C13.4688 3.94772 13.021 3.5 12.4688 3.5V5.5ZM20.5 12.4688C20.5 11.9165 20.0523 11.4688 19.5 11.4688C18.9477 11.4688 18.5 11.9165 18.5 12.4688H20.5ZM17.5 18.5H6.5V20.5H17.5V18.5ZM5.5 17.5V6.5H3.5V17.5H5.5ZM6.5 5.5H12.4688V3.5H6.5V5.5ZM18.5 12.4688V17.5H20.5V12.4688H18.5ZM6.5 18.5C5.94772 18.5 5.5 18.0523 5.5 17.5H3.5C3.5 19.1569 4.84315 20.5 6.5 20.5V18.5ZM17.5 20.5C19.1569 20.5 20.5 19.1569 20.5 17.5H18.5C18.5 18.0523 18.0523 18.5 17.5 18.5V20.5ZM5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5V3.5C4.84315 3.5 3.5 4.84315 3.5 6.5H5.5Z"
    />
    <path
      :fill="props.color"
      d="M9.20711 8.83637C8.81658 8.44585 8.18342 8.44585 7.79289 8.83637C7.40237 9.2269 7.40237 9.86006 7.79289 10.2506L9.20711 8.83637ZM19.2071 7.20711C19.5976 6.81658 19.5976 6.18342 19.2071 5.79289C18.8166 5.40237 18.1834 5.40237 17.7929 5.79289L19.2071 7.20711ZM11.8368 12.8803L11.1297 13.5874L11.8368 12.8803ZM12.1197 12.8803L12.8268 13.5874L12.1197 12.8803ZM7.79289 10.2506L11.1297 13.5874L12.5439 12.1732L9.20711 8.83637L7.79289 10.2506ZM12.8268 13.5874L19.2071 7.20711L17.7929 5.79289L11.4126 12.1732L12.8268 13.5874ZM11.1297 13.5874C11.5984 14.0561 12.3582 14.0561 12.8268 13.5874L11.4126 12.1732C11.725 11.8608 12.2315 11.8608 12.5439 12.1732L11.1297 13.5874Z"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
